import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {filter, first, map, switchMap} from "rxjs/operators";
import {AiAssistantService} from "../../../ai-assistant/service/ai-assistant.service";
import {Utils} from "../../../shared/utils/utils";
import {combineLatest, from} from "rxjs";
import {User} from "../../../user/user";
import {UserSubscription} from "../../../user/user-subscription";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../store";
import {DbStoreState} from "../../../store";
import {BuilderHistoryService} from "../../builder-history.service";
import {BuilderStepsEnum} from "../../builder-tour.enum";
import {ActivatedRoute, Router} from "@angular/router";
import {ChooseBusinessTypeComponent} from "./components/choose-website-type/choose-business-type.component";
import {CreateCompanyInfoComponent} from "./components/create-company-info/create-company-info.component";
import {BuilderSectionsInteractionService} from "../../builder-sections-interaction.service";
import {BuilderGeneratedPageI, PageMetaI} from "../../builder-v2.interface";
import {SafeHtml} from "@angular/platform-browser";
import {
  OutlineGenerationSitemapComponent
} from "./components/outline-generation-sitemap/outline-generation-sitemap.component";
import {GoogleAnalyticsService} from "../../../shared/services/google-analytics/google-analytics.service";
import {CommonBuilderDataService} from "../../services/common-builder-data.service";
import {
  NotificationDialogComponent
} from "../../../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import exampleTexts from "./example-text.json";
import {ChooseStoreTypeComponent} from "./components/choose-store-type/choose-store-type.component";
import {
  CreateProductCategoriesComponent
} from "./components/create-product-categories/create-product-categories.component";
import {PrefilledCompanyInfoComponent} from "./components/prefilled-company-info/prefilled-company-info.component";
import {TriggersService} from "../../services/triggers.service";
import {VibeCodingFlowService} from "../../../shared/services/vibe-coding-flow.service";
import {ReCaptchaV3Service} from "ngx-captcha";
import {Config} from "../../../config/config";
import {BuilderV2Service} from "../../builder-v2.service";
import {DbResponse} from "../../../shared/interceptors/db-response";

@Component({
  selector: 'db-outline-generation',
  templateUrl: './outline-generation.component.html',
  styleUrl: './outline-generation.component.scss',
  standalone: false
})
export class OutlineGenerationComponent implements OnInit {
  @ViewChild('chooseWebsite') chooseWebsite!: ChooseBusinessTypeComponent;
  @ViewChild('createInfo') createInfo!: CreateCompanyInfoComponent;
  @ViewChild('prefilledInfo') prefilledInfo!: PrefilledCompanyInfoComponent;
  @ViewChild('sitemap') sitemap!: OutlineGenerationSitemapComponent;
  @ViewChild('chooseStore') chooseStore!: ChooseStoreTypeComponent;
  @ViewChild('productPage') productPage!: CreateProductCategoriesComponent;

  @Input() fromVibeCoding: boolean = false;
  @Input() isEcommerce: boolean;
  @Input() data = [];
  @Input() popupMode: boolean;
  @Input() domainId: number;
  @Input() uniqueId: string;
  @Input() fromInnerAIPage: boolean;
  @Input() isOnboarding: boolean;
  @Input() fontStyles: SafeHtml[] = [];
  @Input() params: any;
  @Output() paramsChange = new EventEmitter<Record<string, string | number>>();
  @Input() hasEcommerceService: boolean;
  @Input() tourStep: number;
  @Input() isMobile: boolean;
  @Input() outline: BuilderGeneratedPageI;
  @Input() pageMetas: PageMetaI[];
  @Input() prefilledAi: boolean;
  @Input() isMobileAutoGenerate: boolean;
  @Input() prefilledAiData: any;
  @Input() website: any;
  @Output() openMagicLink: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onGenerate: EventEmitter<void> = new EventEmitter<void>();
  @Output() checkSectionTitles: EventEmitter<void> = new EventEmitter<void>();

  step = ['SITE TYPE', 'SITE INFO', 'PAGES', 'COLORS & FONTS'];
  ecomStep = ['STORE TYPE', 'STORE INFO', 'PRODUCT TYPE', 'PAGES', 'COLORS & FONTS'];
  current = 0;
  domainInfo: any = {};
  companyTypesForView: any;
  companyTypes: any;
  storeTypes: any;
  storeTypesForView: any;
  user: User;
  userSubscription: UserSubscription;
  searchedCompanyTypeList = null;
  selectedCategoryType: string;
  builderStep = BuilderStepsEnum;
  ecomStepMapping = [
    BuilderStepsEnum.CHOOSE_BUSINESS_TYPE,
    BuilderStepsEnum.FILL_COMPANY_INFO,
    BuilderStepsEnum.PRODUCT_TYPE,
    BuilderStepsEnum.SHOW_CANVAS,
    BuilderStepsEnum.SHOW_DESIGN,
    BuilderStepsEnum.SHOW_FINALIZE
  ];
  builderStepMapping = [
    BuilderStepsEnum.CHOOSE_BUSINESS_TYPE,
    BuilderStepsEnum.FILL_COMPANY_INFO,
    BuilderStepsEnum.SHOW_CANVAS,
    BuilderStepsEnum.SHOW_DESIGN,
    BuilderStepsEnum.SHOW_FINALIZE
  ];
  categoryTexts: { [key: string]: string } = exampleTexts['business'];
  categoryTextsEcommerce = exampleTexts['ecommerce'];
  showActionsLine = false;
  startAnimations$ = this._triggerService.startSidebarAnimations;
  vibeCodingFlow: boolean;
  protected readonly from = from;


  constructor(private _aiAssistantService: AiAssistantService,
              private _store: Store<DbStoreState>,
              private _router: Router,
              private _route: ActivatedRoute,
              public builderHistoryService: BuilderHistoryService,
              public builderInteractionsService: BuilderSectionsInteractionService,
              public _googleAnalyticsService: GoogleAnalyticsService,
              private _dialogService: DialogService,
              public _triggerService: TriggersService,
              private _cdr: ChangeDetectorRef,
              private _vibeCodingFlowService: VibeCodingFlowService,
              private _commonDataService: CommonBuilderDataService,
              private _reCaptchaV3Service: ReCaptchaV3Service,
              private _builderV2Service: BuilderV2Service
  ) {
    const websiteTypeParam = this._route.snapshot.queryParamMap.get('websiteType');
    this.isEcommerce = websiteTypeParam === 'ecommerce' || this.builderInteractionsService.websiteType.value === 'ecommerce';
  }


  ngOnInit() {
    if (this.isMobileAutoGenerate) {
      this.builderHistoryService.builderStep.next(BuilderStepsEnum.SHOW_FINALIZE);
    }
    if (this.prefilledAi) {
      this.ecomStep = ['STORE TYPE', 'STORE INFO', 'PAGES', 'COLORS & FONTS'];
      this.ecomStepMapping = [
        BuilderStepsEnum.CHOOSE_BUSINESS_TYPE,
        BuilderStepsEnum.FILL_COMPANY_INFO,
        BuilderStepsEnum.SHOW_CANVAS,
        BuilderStepsEnum.SHOW_DESIGN,
        BuilderStepsEnum.SHOW_FINALIZE
      ];
    }
    if (this.fromVibeCoding) {
      this.step = ['SITE INFO', 'SITE STRUCTURE'];
      this.builderStepMapping = [
        BuilderStepsEnum.FILL_COMPANY_INFO,
        BuilderStepsEnum.SHOW_CANVAS,
        BuilderStepsEnum.SHOW_FINALIZE
      ];
    }
    this.vibeCodingFlow = this._vibeCodingFlowService.isVibeCodingFlow() || this.website?.isWVC;

    this._runInitialSubscriptions();
    this.isEcommerce ? this.getStoreTypes() : this._getCompanyTypes();
  }

  private _getCompanyTypes(): void {
    if (!this.companyTypes) {
      this._aiAssistantService.getCategories(false, false)
        .pipe(
          first(response => !!response),
        )
        .subscribe(response => {
          if (response.success) {
            this.companyTypes = response.data.map(({name, title, type, group, keywords}) => (
              {label: title, value: title, type: type, group: group, keywords}
            ));
            this.companyTypesForView = this.companyTypes;
          }
        });
    } else {
      this.companyTypesForView = this.companyTypes;
    }
  }

  private getStoreTypes(): void {
    if (!this.companyTypes) {
      this._aiAssistantService.getCategories(true, !this.userSubscription || (this.userSubscription && !!this.userSubscription?.plan?.woocommerceService))
        .pipe(
          first(response => !!response),
        )
        .subscribe(response => {
          if (response.success) {
            this.storeTypes = response.data.map(({name, title, type, group, keywords}) => (
              {label: title, value: title, type: type, group: group, keywords}
            ));
            this.storeTypesForView = this.storeTypes;
          }
        });
    } else {
      this.storeTypesForView = this.storeTypes;
    }
  }


  private _runInitialSubscriptions(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUser),
          this._store.select(fromStore.getUserSubscription),
        )),
        first()
      )
      .subscribe(([user, userSubscription]) => {
        this.user = user;
        this.userSubscription = userSubscription;
      });
  }

  public setCompanyType(type: string, isEcommerce: boolean = false, fromLandingPage: boolean = false, dontChangeStep: boolean = false): void {
    this._aiAssistantService.getTemplateQuestions(type, isEcommerce, fromLandingPage)
      .pipe(
        first(response => !!response)
      )
      .subscribe(response => {
        if (response && response.data) {
          const allData = response.data && response.data.questions ? Utils.sortObjectByKey(response.data.questions, "name_desc") : {};
          this.data = Object.keys(allData).length ? Object.keys(allData).map(key => allData[key]) : [];
          this.builderInteractionsService.disableNextButton.next(!this.data[0]);
          this._cdr.markForCheck();
        }
      });
  }

  public back(data, value): void {
    this.params = {...this.params, ...data};
    this.builderHistoryService.builderStep.next(value - 1);
  }

  public next(data, value): void {
    this.params = {...this.params, ...data};
    this.builderHistoryService.builderStep.next(value + 1);
  }

  public setDefault(): void {
    this._router.navigate([this.user ? 'setup/ai-demo' : '/setup-onboarding/start-ai-website-building']);
    this.isEcommerce = !this.isEcommerce;
    this.builderHistoryService.clearFormData();
    localStorage.removeItem('dbOnboardingDomainName');
    localStorage.removeItem('dbOnboardingDomainNameInitial');
    localStorage.removeItem('dbOnboardingDomainInfo');
    localStorage.removeItem('prefilledAiData');
  }

  onBackClick() {
    if ([this.builderStep.CHOOSE_BUSINESS_TYPE].includes(this.builderHistoryService.builderStep.value)) {
      this.setDefault();
    } else if (this.builderHistoryService.builderStep.value === this.builderStep.FILL_COMPANY_INFO) {
      const formValue = this.createInfo?.outlineFormGroup?.value;
      const data = {formData: formValue, domainInfo: this.createInfo?.domainInfo};
      this.back(data?.formData, this.builderStep.FILL_COMPANY_INFO);
    } else if (this.builderHistoryService.builderStep.value === this.builderStep.PRODUCT_TYPE) {
      const formValue = this.productPage?.outlineFormGroup?.value;
      const data = {formData: formValue};
      this.back(data?.formData, this.builderStep.PRODUCT_TYPE);
    } else if (this.builderHistoryService.builderStep.value === this.builderStep.SHOW_CANVAS) {
      const data = this.prefilledAi ? this.prefilledAiData : this.data[0];
      localStorage.removeItem('builder_history');
      this.builderHistoryService.resetSubjects();
      this.builderInteractionsService.resetSubjects();
      this.back(data, !this.isEcommerce ? this.builderStep.SHOW_CANVAS - 1 : this.builderStep.SHOW_CANVAS);
    } else if (this.builderHistoryService.builderStep.value === this.builderStep.SHOW_DESIGN) {
      this.builderHistoryService.builderStep.next(this.builderStep.SHOW_CANVAS);
    }
  }

  onNextClick() {
    this._commonDataService.combinedOutline = this._vibeCodingFlowService.isCombinedOutline();
    if ([this.builderStep.CHOOSE_BUSINESS_TYPE].includes(this.builderHistoryService.builderStep.value)) {
      const websiteType = this.isEcommerce ? this.chooseStore : this.chooseWebsite;
      this.isEcommerce ? websiteType.proceedToNextQuestion() : websiteType.proceedToNextQuestion();
      const data = {
        business_type: websiteType.selectedCompanyType,
        business_category: websiteType.selectedBusinessCategory
      };

      if (this.isMobile) {
        const dataToPass = {
          formGroupData: this.data[0],
          oldFormData: this.params = {...this.params, ...data},
          isBusinessType: this.selectedCategoryType === 'basic',
        };
        this.builderHistoryService.saveFormData(dataToPass);
        this.user ? this.next(data, this.builderStep.CHOOSE_BUSINESS_TYPE) : this._router.navigate([`../fill-company-info`], {
          relativeTo: this._route,
        });
      } else {
        this.next(data, this.builderStep.CHOOSE_BUSINESS_TYPE);
      }
    } else if (this.builderHistoryService.builderStep.value === this.builderStep.FILL_COMPANY_INFO) {
      if (this.prefilledAi) {
        this._getBusinessDescData(this.createInfo?.outlineFormGroup?.value, true);
        const companyInfo = this.prefilledInfo;

        if (this.isEcommerce) {
          const data = {
            websiteType: companyInfo.websiteType,
            business_category: companyInfo.outlineFormGroup?.value?.business_type,
            store_name: companyInfo.outlineFormGroup?.value?.business_name,
            business_type: companyInfo.outlineFormGroup?.value?.business_type,
            store_description: companyInfo.outlineFormGroup?.value?.business_description,
          };
          this.next(data, this.builderStep.FILL_COMPANY_INFO);
          this.prefilledInfo.ecommerceNext();
        } else {
          const data = {
            websiteType: companyInfo.websiteType,
            business_category: companyInfo.outlineFormGroup?.value?.business_type,
            business_name: companyInfo.outlineFormGroup?.value?.business_name,
            business_type: companyInfo.outlineFormGroup?.value?.business_type,
            business_description: companyInfo.outlineFormGroup?.value?.business_description,
          };
          this.next(data, this.builderStep.FILL_COMPANY_INFO + 1);
          this.prefilledInfo.onGenerate();
        }
      } else {
        const formValue = this.createInfo?.outlineFormGroup?.value;
        const data = {formData: formValue, domainInfo: this.createInfo?.domainInfo};

        if (this.fromVibeCoding) {
          // For vibe coding flow, use the enhanced business description generation
          const initialDesc = formValue?.business_description;

          if (initialDesc) {
            this.builderInteractionsService.loading.next(true);
            this._getBusinessDescData(initialDesc);
          } else {
            // Fallback to regular flow if no description
            if (this.isEcommerce) {
              this.next(data?.formData, this.builderStep.FILL_COMPANY_INFO);
              this.createInfo.ecommerceNext();
            } else {
              this.next(data?.formData, this.builderStep.FILL_COMPANY_INFO + 1);
              this.createInfo.onGenerate();
            }
            this._getBusinessDescData(this.createInfo?.outlineFormGroup?.value, true);
          }
        } else {
          // Regular flow for non-vibe coding
          if (this.isEcommerce) {
            this.next(data?.formData, this.builderStep.FILL_COMPANY_INFO);
            this.createInfo.ecommerceNext();
          } else {
            this.next(data?.formData, this.builderStep.FILL_COMPANY_INFO + 1);
            this.createInfo.onGenerate();
          }
          if (this.popupMode) {
            this._triggerService.getPageMetas.next();
          }
          this._getBusinessDescData(this.createInfo?.outlineFormGroup?.value, true);
        }
      }
    } else if (this.builderHistoryService.builderStep.value === this.builderStep.PRODUCT_TYPE) {
      const formValue = {ecom_data: this.productPage?.generatedServices};
      const data = {formData: formValue?.ecom_data};

      this.next(data, this.builderStep.PRODUCT_TYPE);
      this.productPage.onGenerate();
    } else if (this.builderHistoryService.builderStep.value === this.builderStep.SHOW_CANVAS) {
      this.checkSectionTitles.emit();
      this.builderHistoryService.builderStep.next(this.builderStep.SHOW_DESIGN);
    }
  }

  onClickGenerate() {
    if (this.prefilledAi) {
      // Clear the fresh open flag when user manually starts generation
      this.builderInteractionsService.prepareDialogForFreshOpen.next(false);
      this.onGenerate.emit();
      return;
    }
    this.generateWebsite();
  }

  generateWebsite() {
    // Clear the fresh open flag when user manually starts generation
    this.builderInteractionsService.prepareDialogForFreshOpen.next(false);
    this.builderInteractionsService.saveCustomizationChanges.next();
    this.onGenerate.emit();
  }

  reset() {
    this._dialogService.addDialog(NotificationDialogComponent, {
      header: 'Are you sure you want to leave this page?',
      message: 'Changes you made may not be saved.',
      buttonText: 'Leave',
      showCancelButton: true,
      buttonColor: 'black',
      hasAdminLink: false,
      action: 'preview',
      hasCloseButton: false
    }).subscribe((confirmed: string): void => {
      if (confirmed) {
        localStorage.removeItem('builder_history');
        localStorage.removeItem('prefilledAiData');
        this._router.navigate([!this.user ? '/setup-onboarding/start-ai-website-building' : '../']);
        this.builderHistoryService.resetSubjects();
        this.builderInteractionsService.resetSubjects();
      }
    });
  }

  public getTextsForCategory(businessCategory: string): string[] {
    const firstText = this.getTextForCategory(businessCategory);
    const otherTexts = this.getOtherTexts(businessCategory);

    return [firstText, ...otherTexts];
  }

  private getTextForCategory(businessCategory: string): string {
    switch (businessCategory) {
      case 'cv portfolio':
        return this.categoryTexts['portfolio'];
      case 'restaurant':
        return this.categoryTexts['restaurant'];
      case 'education teach':
        return this.categoryTexts['school'];
      case 'blog':
        return this.categoryTexts['blog'];
      default:
        return this.categoryTexts['default'];
    }
  }

  private getOtherTexts(businessCategory: string): string[] {
    const firstText = this.getTextForCategory(businessCategory);
    return Object.entries(this.categoryTexts)
      .filter(([key, text]) => text !== firstText)
      .map(([key, text]) => text);
  }

  getSteps(isEcommerce: boolean): string[] {
    this.vibeCodingFlow = this._vibeCodingFlowService.isVibeCodingFlow() || this.website?.isWVC;
    const baseSteps = isEcommerce ? this.ecomStep : this.step;
    let _steps = baseSteps;
    if (this.prefilledAi) {
      _steps = baseSteps.filter(step => !['SITE TYPE', 'STORE TYPE'].includes(step));
    }
    if (this.vibeCodingFlow) {
      _steps = this.step.filter(step => !['SITE TYPE', 'COLORS & FONTS'].includes(step));
    }
    return _steps;
  }

  private _getBusinessDescData(initialDesc, onlySendGaEvent = false) {
    this._reCaptchaV3Service.execute(Config.googleRecaptcha, 'signup', (token) => {
      this.vibeCodingFlow = this._vibeCodingFlowService.isVibeCodingFlow() || this.website?.isWVC;
      const generationMethod = this.vibeCodingFlow && typeof initialDesc === "string" ? 'generateAiBuilderDesc' : 'generateAiSectionBuilderDesc';
      let images = null;
      let figmaLink = null;

      if (this.vibeCodingFlow) {
        const {imagesArray, figma} = this._setFigmaAndImages();
        images = imagesArray;
        figmaLink  = figma;
      }
      // Pass additional parameters to the generateAiBuilderDesc method
      this._builderV2Service[generationMethod](initialDesc, token, null, null, images, false)
        .pipe(
          filter((response: DbResponse): boolean => !!response),
          map((response: DbResponse) => {
            if (response.success) {
              if (response.data.enhanced_description) {
                response.data = {
                  ...response.data,
                  site_description: response.data.enhanced_description,
                  initial_description: initialDesc,
                  industry_name: response.data.business_type,
                  analysis: this.vibeCodingFlow ? response.data.analysis : '',
                  figma_link: figmaLink,
                  images: images,
                  website_type: response.data.website_type,
                };
              }
            }
            return response;
          }),
          first()
        )
        .subscribe((response) => {
          this.builderInteractionsService.vibeCodingFigma = null;
          this.builderInteractionsService.vibeCodingImages = [];
          if (response.success) {
            if (response.data) {
              if (onlySendGaEvent) {
                return;
              }
              this._prefilledOutlineGeneration(response.data);
            }
          } else {
            this._sendOnlyDescription();
          }
        });
    });
  }

  private _sendOnlyDescription(): void {
    if (this.isEcommerce) {
      this.next(this.prefilledAiData, this.builderStep.FILL_COMPANY_INFO);
      this.createInfo?.ecommerceNext();
    } else {
      this.next(this.prefilledAiData, this.builderStep.FILL_COMPANY_INFO + 1);
      this.createInfo?.onGenerate();
    }
  }

// ... existing code ...

  private _prefilledOutlineGeneration(companyInfo: any): void {
    const {business_name, industry_name, initial_description, site_description, website_type, figma_url, images, analysis} = companyInfo;
    let formValue = {
      business_description: site_description,
      business_type: industry_name,
      figma_url: figma_url || undefined,
      images: images || undefined,
      business_name,
      website_type,
      initial_description,
      analysis: analysis || undefined,
    };
    this.builderInteractionsService.websiteType.next(website_type);
    this._commonDataService.websiteType = website_type;
    this.builderInteractionsService.siteInfo.next({
      ...formValue
    });
    const {initial_description: _, ...outlineFormValue} = formValue;

    if (website_type === 'ecommerce' && !this.vibeCodingFlow) {
      this.createInfo?.ecommerceNext();

      // Handle the async product generation
      this._generateProductsInBackground(outlineFormValue).subscribe((ecomData) => {
        if (ecomData) {
          // Now we have the actual data, so we can set formValue with ecom_data
          const updatedFormValue = {
            business_description: site_description,
            business_type: industry_name,
            business_name,
            initial_description,
            ecom_data: {
              categories: ecomData.generatedServices,
              blacklisted_categories: ecomData.generatedServices,
              collections: ecomData.collections
            },
            website_type,
            figma_url: figma_url || undefined,
            images: images || undefined,
            analysis: analysis || undefined,
          };

          this.builderInteractionsService.siteInfo.next({
            ...updatedFormValue
          });
          this.builderInteractionsService.loading.next(false);

          this.next(updatedFormValue, this.builderStep.FILL_COMPANY_INFO + 1);
          this.createInfo?.onGenerate();
        }
      });
    } else {
      this.builderInteractionsService.loading.next(false);
      this.next(formValue, this.builderStep.FILL_COMPANY_INFO + 1);
      this.createInfo?.onGenerate();
    }
  }

  private _generateProductsInBackground(formValue: any) {
    return this._builderV2Service.generateProducts(formValue, this.domainId, this.uniqueId)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        map((response) => {
          if (response.success && response.data) {
            return {
              generatedServices: response.data['categories'],
              blacklisted_categories: response.data['categories'],
              collections: response.data['collections'],
            };
          }
          return null;
        }),
        first()
      );
  }

  private _setFigmaAndImages() {
    let images = this.builderInteractionsService.vibeCodingImages;
    const figma = this.builderInteractionsService.vibeCodingFigma;
    if (images && !!images.length) {
      if (figma?.screenshot_url) {
        images = [{filename: figma.node_name, url: figma.screenshot_url}, ...images];
      }
    } else {
      if (figma?.screenshot_url) {
        images = [{filename: figma.node_name, url: figma.screenshot_url}];
      }
    }

    return {
      imagesArray: images?.length ? images : null,
      figma: figma?.screenshot_url || null
    };
  }
}
